import styled from 'styled-components';

export const Container = styled.div`
  width: 90%;
  max-width: 1024px;
  margin: 30px auto 50px auto;
`;
